class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = this.querySelector('#cart-notification');
    this.notificationBody = this.querySelector('#cart-notification-product');
    this.header = document.querySelector('sticky-header');

    this.onBodyClick = this.handleBodyClick.bind(this);

    document.querySelectorAll('product-form form').forEach(form => {
      form.addEventListener('submit', (event) => this.addToCart(event));
    });

    this.querySelector('.cart-notification__close').addEventListener('click', () => {
      this.close();
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.continue-shopping-button')) {
        this.close();
      }
    });

    this.setupQuantityButtons();
  }

  addToCart(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', true);
      submitButton.disabled = true;
    }

    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then(() => {
        this.renderContents();
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-disabled');
        }
      })
      .catch((error) => {
        console.error('Add to cart error:', error);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-disabled');
        }
      });
  }

  setupQuantityButtons() {
    this.notificationBody.addEventListener('click', (event) => {
      const button = event.target.closest('.quantity-button');
      if (button) {
        event.preventDefault();
        const line = button.dataset.line;
        const quantityInput = button.parentElement.querySelector('input[data-cart-quantity]');
        let quantity = parseInt(quantityInput.value);

        if (button.classList.contains('plus')) {
          quantity++;
        } else if (button.classList.contains('minus')) {
          quantity--;
        }
        if (quantity < 0) quantity = 0;

        this.updateCartQuantity(line, quantity);
      }
    });
  }

  updateCartQuantity(line, quantity) {
    fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    })
      .then(() => {
        this.renderContents();
      })
      .catch(error => console.error('Update cart quantity error:', error));
  }

  renderContents() {
    fetch('/?sections=cart-notification-product,header')
      .then((response) => response.json())
      .then((sections) => {
        // If the cart is now empty, close drawer
        if (!sections['cart-notification-product'].trim()) {
          this.close();
          return;
        }

        // Update cart drawer contents
        this.notificationBody.innerHTML = sections['cart-notification-product'];

        // Update cart bubble (force header replacement to ensure update)
        const parser = new DOMParser();
        const headerHTML = parser.parseFromString(sections['header'], 'text/html');

        const newHeader = headerHTML.querySelector('header');
        const currentHeader = document.querySelector('header');
        if (newHeader && currentHeader) {
          currentHeader.innerHTML = newHeader.innerHTML;
        }

        // Update discount and total
        const discountSpan = document.querySelector('[data-cart-discount]');
        const totalSpan = document.querySelector('[data-cart-total]');
        const discountElement = document.getElementById('cart-notification-discount');
        const totalElement = document.getElementById('cart-notification-total');

        if (discountSpan && discountElement) {
          discountElement.textContent = discountSpan.getAttribute('data-cart-discount');
          discountElement.style.color = 'red';
        }

        if (totalSpan && totalElement) {
          totalElement.textContent = totalSpan.getAttribute('data-cart-total');
        }

        this.setupQuantityButtons();
        this.open();
      });
  }

  open() {
    this.notification.classList.add('active');
    document.body.addEventListener('click', this.onBodyClick);
    this.trapFocus(this.notification);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.removeTrapFocus(this.notification);

    const activeSubmitButton = document.querySelector('product-form button[type="submit"]');
    if (activeSubmitButton) {
      activeSubmitButton.disabled = false;
      activeSubmitButton.removeAttribute('aria-disabled');
    }
  }

  handleBodyClick(event) {
    if (!this.contains(event.target) && this.notification.classList.contains('active')) {
      this.close();
    }
  }

  trapFocus(element) {
    element.focus();
  }

  removeTrapFocus(element) {
    element.blur();
  }
}

customElements.define('cart-notification', CartNotification);